import {
    Form, FormButton, FormButtonContainer, FormItem, FormSubmitHandler, TextInput, useAlerts, useForm,
} from "@sis/react-library"
import { ExampleDto } from "./FormSamplesCustomLayoutPage";
import { Box, Grid } from "@mui/material";

/////////////////////////////////////////////////////////////////////////////////////////////
// You have full control over the layout, and can add any tags under the 
// FormControl component formatting the content.
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesCustomLayoutFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesCustomLayoutForm = ({
    onSubmit, submitting
}: FormSamplesCustomLayoutFormProps) => {

    const formName = 'FormCustomLayout';

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <Box
                sx={{ border: 1, background: 'lightgrey', padding: 5 }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ md: 6 }}>
                        <FormItem<T>
                            formField="firstName"
                            label="First Name"
                            element={<TextInput maxLength={20} />}
                        />
                    </Grid>
                    <Grid size={{ md: 6 }}>
                        <FormItem<T>
                            formField="lastName"
                            label="Last Name"
                            element={<TextInput maxLength={20} />}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box
                sx={{ border: 1, background: 'rgb(230, 255, 255)', padding: 5 }}
            >
                <FormItem<T>
                    formField="about"
                    label="About the person"
                    element={<TextInput />}
                />
            </Box>
            <FormButtonContainer>
                <Box
                    sx={{ border: 1, background: 'rgb(255, 255, 230)', padding: 5, width: '300px' }}
                >
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6 }}>
                            <FormButton
                                formButtonText='Cancel'
                                onClick={() => { handleCancel() }}
                            />
                        </Grid>
                        <Grid size={{ md: 6 }}>
                            <FormButton
                                formButtonText='Submit'
                                submitButton
                            />
                        </Grid>
                    </Grid>
                </Box>
            </FormButtonContainer>
        </Form>
    )
}
